import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CredentialsApiService } from '@services/api-calls/credentials-api.service';
import { ProgressBarComponent } from 'app/components/shared/progress-bar/progress-bar.component';

@Component({
    selector: 'app-activate',
    templateUrl: './activate.component.html',
    styleUrls: ['./activate.component.scss'],
})
export class ActivateComponent implements OnInit {
    public uidb: string;
    public token: string;
    public active_error: boolean = false;

    @ViewChild(ProgressBarComponent, { static: false })
    pbComponent: ProgressBarComponent;

    constructor(
        private route: ActivatedRoute,
        private _credentialsApiService: CredentialsApiService
    ) {}

    ngOnInit(): void {
        this.route.paramMap.subscribe((params) => {
            this.token = params.get('token');
            this.uidb = params.get('uidb');
        });

        if (this.uidb === '' || this.token === '') {
            this.active_error = true;
        } else {
            this.activateUser();
        }
    }

    activateUser(): void {
        this.pbComponent.middle();
        this._credentialsApiService
            .activateUser(this.uidb, this.token)
            .subscribe(
                (response) => {
                    this.pbComponent.end();
                },
                (error) => {
                    this.active_error = true;
                    console.log(error);
                    this.pbComponent.error();
                }
            );
    }
}
